import React, {useCallback} from "react";
import {useForm} from "react-hook-form";
import {usePromiseTracker} from "react-promise-tracker";
import {Subject} from "rxjs";
import {showToast} from "common";
import {useObservable} from "rxsupport";
import {ReportModal} from "../../form-components/ReportModal";
import {MissingDocumentationInput} from "../../domain";
import {MissingDocumentationForm} from "./MissingDocumentationForm";

type Props = {
    visible$: Subject<boolean>;
    onFinished: (formValues: MissingDocumentationInput | null) => Promise<void>;
};

export function MissingDocumentationFormAuthModal({visible$, onFinished}: Props) {
    const visible = useObservable(visible$, false);

    const methods = useForm<MissingDocumentationInput>({
        defaultValues: {
            missingDocumentations: "",
            otherDocumentations: ""
        }
    });


    const {promiseInProgress} = usePromiseTracker();

    const onCancel = useCallback(async () => {
        showToast.warning(`Submission for Missing Documentation is cancelled`);
        methods.reset();
        visible$.next(false);
    }, [methods, visible$]);

    return (
        <ReportModal visible={visible} title={'Missing Documentation'} onClose={onCancel}>
            <MissingDocumentationForm visible$={visible$} methods={methods} onFinished={onFinished} onCancel={onCancel}
                                      externalLoading={promiseInProgress}/>
        </ReportModal>
    );
}
